<!--
 * @Descripttion: 
 * @version: 0.1
 * @Author: lixianbing
 * @Date: 
 * @LastEditors: wanglong
 * @LastEditTime: 2021-07-12 16:07:48
 -->
<template>
  <div class="home">
    <!-- 顶部模块 -->
    <div class="box">
      <div class="header">
        <div class="title">基本信息 Basic information</div>
        <div>
          <el-button type="primary" v-if="uploads"
            ><i class="iconfont iconshangchuan"></i>上传附件分享地址</el-button
          >
          <el-button type="primary" @click="imports = true"
            ><i class="iconfont icondaochu"></i>导出报名表</el-button
          >
        </div>
      </div>
      <div class="cont">
        <ul class="part1">
          <li>
            <el-input placeholder="请输入内容" v-model="basce.teamChorusCh">
              <template slot="prepend">合唱团名称：</template>
            </el-input>
            <el-input placeholder="请输入内容" v-model="basce.countryCh">
              <template slot="prepend">国家：</template>
            </el-input>
          </li>
          <li>
            <el-input placeholder="请输入内容" v-model="basce.teamChorusEn">
              <template slot="prepend">Name of the group：</template>
            </el-input>
            <el-input placeholder="请输入内容" v-model="basce.countryEn">
              <template slot="prepend">Country：</template>
            </el-input>
          </li>
          <li>
            <el-input placeholder="请输入内容" v-model="basce.streetCh">
              <template slot="prepend">通讯地址：</template>
            </el-input>
            <el-input placeholder="请输入内容" v-model="basce.teamRegionNameCh">
              <template slot="prepend">省/城市：</template>
            </el-input>
            <el-input placeholder="请输入内容" v-model="basce.zipCh">
              <template slot="prepend">州/省 邮政编码：</template>
            </el-input>
          </li>
          <li>
            <el-input placeholder="请输入内容" v-model="basce.streetEn">
              <template slot="prepend">Street：</template>
            </el-input>
            <el-input placeholder="请输入内容" v-model="basce.teamRegionNameEn">
              <template slot="prepend">City:</template>
            </el-input>
            <el-input placeholder="请输入内容" v-model="basce.zipEn">
              <template slot="prepend">State/Province & Zip Code：</template>
            </el-input>
          </li>
          <li>
            <el-input
              placeholder="（国家代码-城市区号-电话号码）"
              v-model="basce.teamPhoneCh"
            >
              <template slot="prepend">电话：</template>
            </el-input>
            <el-input placeholder="请输入内容" v-model="basce.faxCh">
              <template slot="prepend">传真：</template>
            </el-input>
          </li>
          <li>
            <el-input
              placeholder="Country code / area code / number"
              v-model="basce.teamPhoneEn"
            >
              <template slot="prepend">Phone：</template>
            </el-input>
            <el-input placeholder="请输入内容" v-model="basce.faxEn">
              <template slot="prepend">Fax：</template>
            </el-input>
          </li>
          <li>
            <el-input placeholder="请输入内容" v-model="basce.teamEmailCh">
              <template slot="prepend">电子邮箱：</template>
            </el-input>
          </li>
          <li>
            <el-input placeholder="请输入内容" v-model="basce.teamEmailEn">
              <template slot="prepend">E-mail：</template>
            </el-input>
          </li>
          <li>
            <el-input placeholder="请输入内容" v-model="basce.websiteCh">
              <template slot="prepend">合唱团网址：</template>
            </el-input>
          </li>
          <li>
            <el-input placeholder="请输入内容" v-model="basce.websiteEn">
              <template slot="prepend">Website：</template>
            </el-input>
          </li>
          <li>
            <el-input placeholder="请输入内容" v-model="basce.yearCh">
              <template slot="prepend">合唱团成立年份：</template>
            </el-input>
          </li>
          <li>
            <el-input placeholder="请输入内容" v-model="basce.yearEn">
              <template slot="prepend">Year choir was founded：</template>
            </el-input>
          </li>
          <li>
            <el-input placeholder="请输入内容" v-model="basce.teamNumCh">
              <template slot="prepend"> 团队人数：</template>
            </el-input>
          </li>
          <li>
            <el-input placeholder="请输入内容" v-model="basce.teamNumEn">
              <template slot="prepend">Team size：</template>
            </el-input>
          </li>
        </ul>
        <contact
          ref="Contactperson"
          v-if="Contactperson.type == 1"
          :Contactpersonh="Contactperson"
        ></contact>
        <conductor
          ref="Conductor"
          v-if="Conductor.type == 1"
          :Conductorh="Conductor"
        ></conductor>
        <part4
          ref="conductors"
          v-if="conductors.type == 1"
          :conductorsh="conductors"
        ></part4>
        <part5
          ref="organizations"
          v-if="organizations.type == 1"
          :organizationsh="organizations"
        ></part5>
        <part6
          ref="Organizainfor"
          v-if="Organizainfor.type == 1"
          :Organizainforh="Organizainfor"
        ></part6>
        <part7
          ref="Lengthstay"
          v-if="Lengthstay.type == 1"
          :Lengthstayh="Lengthstay"
        ></part7>
        <part8
          ref="numberrooms"
          v-if="numberrooms.type == 1"
          :numberroomsh="numberrooms"
        ></part8>
        <part9
          ref="Transportation"
          v-if="Transportation.type == 1"
          :Transportationh="Transportation"
        ></part9>
        <part10
          ref="activities"
          v-if="activities.type == 1"
          :activitiesh="activities"
        ></part10>
        <part11
          ref="documents"
          v-if="documents.type == 1"
          :documentsh="documents"
        ></part11>
        <part12 ref="Scores" v-if="Scores.type == 1" :Scoresh="Scores"></part12>
        <li class="uploadform">
          <div>点击下载报名表</div>
          <div style="width: 168px">
            <el-button @click="uploa" style="float: left; margin-top: 15px"
              >下载</el-button
            >
            <el-upload
              style="float: right"
              class="upload-demo"
              action=""
              :show-file-list="false"
              :http-request="myUpload"
            >
              <el-button>替换</el-button>
            </el-upload>
          </div>
        </li>
        <div class="bottoms" style="margin-top: 30px">
          <el-button type="primary" @click="dialogTableVisible = true"
            >提交</el-button
          >
          <el-button type="primary" @click="submits(0)">保存</el-button>
          <el-button>取消</el-button>
        </div>
      </div>
    </div>
    <el-dialog title="特别提示" :visible.sync="dialogTableVisible">
      <p class="tip">
        注：请确认信息是否正确的，<br />
        确认提交之后将无法修改报名信息！
      </p>
      <div class="btnbox">
        <button @click="submits(1)">确定</button>
        <button class="info" @click="dialogTableVisible = false">取消</button>
      </div>
    </el-dialog>
    <el-dialog title="特别提示" :visible.sync="imports">
      <p class="tip">请确认是否导出</p>
      <div class="btnboxs">
        <button @click="(uploads = true), (imports = false)">确定</button>
        <button class="info" @click="imports = false">取消</button>
      </div>
    </el-dialog>
    <el-dialog title="特别提示" :visible.sync="dialogVisible2">
      <span
        >已保存成功<br />
        {{ timee }} 秒后返回报名界面
      </span>
    </el-dialog>
  </div>
</template>

<script>
import contact from "../formbox/contact";
import conductor from "../formbox/conductor";
import part4 from "../formbox/part4";
import part5 from "../formbox/part5";
import part6 from "../formbox/part6";
import part7 from "../formbox/part7";
import part8 from "../formbox/part8";
import part9 from "../formbox/part9";
import part10 from "../formbox/part10";
import part11 from "../formbox/part11";
import part12 from "../formbox/part12";
import {
  apply_detail,
  applysubmit,
  // template_file,
  upload,
  applyupdate,
} from "@/api/file"; // 接口导入
export default {
  components: {
    contact,
    conductor,
    part4,
    part5,
    part6,
    part7,
    part8,
    part9,
    part10,
    part11,
    part12,
  },
  computed: {},
  data() {
    return {
      state: 2,
      files: "",
      fileUrl: "",
      dialogTableVisible: false,
      dialogVisible2: false,
      uploads: false,
      imports: false,
      dialogVisible: false,
      value: "",
      activityName: "",
      teamNum: "",
      basce: {
        teamChorusCh: "", // 团队合唱团中文名称
        teamChorusEn: "",
        teamPhoneCh: "", //团队电话中文
        teamPhoneEn: "",
        teamEmailCh: "", //团队电子邮箱
        teamEmailEn: "",
        teamNumCh: "", //团队人数
        teamNumEn: "",
        teamRegionNameCh: "", // 团队地区
        teamRegionNameEn: "",
        countryCh: "", //国家
        countryEn: "",
        streetCh: "", //住址
        streetEn: "",
        zipCh: "", //邮政编码
        zipEn: "",
        faxCh: "", //传真
        faxEn: "",
        websiteCh: "", //网址
        websiteEn: "",
        yearCh: "", //年份
        yearEn: "",
      },
      timee: 3,
      Contactperson: {
        type: 0,
        data: null,
      },
      Conductor: {
        type: 0,
        data: null,
      },
      conductors: {
        type: 0,
        data: null,
      },
      organizations: {
        type: 0,
        data: null,
      },
      Organizainfor: {
        type: 0,
        data: null,
      },
      Lengthstay: {
        type: 0,
        data: null,
      },
      numberrooms: {
        type: 0,
        data: null,
      },
      Transportation: {
        type: 0,
        data: null,
      },
      activities: {
        type: 0,
        data: null,
      },
      documents: {
        type: 0,
        data: null,
      },
      Scores: {
        type: 0,
        data: null,
      },
    };
  },

  created() {},
  mounted() {
    // this.getdeils();
    localStorage.setItem("states", 1);
  },
  methods: {
    //图片上传
    myUpload(params) {
      let formData = new FormData();
      formData.append("file", params.file);
      upload(formData).then((res) => {
        if (res.code == 200) {
          this.$message.success("上传成功");
          this.fileUrl = res.data.fileUrl;
        }
      });
    },
    //查询用户已报名详情
    getdeils() {
      let data = {
        activityId: "123459",
      };
      apply_detail(data).then((res) => {
        this.basce.teamChorusCh = res.data.teamChorusCh;
        this.basce.teamChorusEn = res.data.teamChorusEn;
        this.basce.teamPhoneCh = res.data.teamPhoneCh;
        this.basce.teamPhoneEn = res.data.teamPhoneEn;
        this.basce.teamEmailCh = res.data.teamEmailCh;
        this.basce.teamEmailEn = res.data.teamEmailEn;
        this.basce.teamNumCh = res.data.teamNumCh;
        this.basce.teamNumEn = res.data.teamNumEn;
        this.basce.teamRegionNameEn = res.data.teamRegionNameEn;
        this.basce.teamRegionNameCh = res.data.teamRegionNameCh;
        this.basce.websiteCh = res.data.templateData.websiteCh;
        this.basce.websiteEn = res.data.templateData.websiteEn;
        this.basce.yearCh = res.data.templateData.yearCh;
        this.basce.yearEn = res.data.templateData.yearEn;
        this.basce.streetCh = res.data.templateData.streetCh;
        this.basce.streetEn = res.data.templateData.streetEn;
        this.basce.countryCh = res.data.templateData.countryCh;
        this.basce.countryEn = res.data.templateData.countryEn;
        this.basce.zipCh = res.data.templateData.zipCh;
        this.basce.zipEn = res.data.templateData.zipEn;
        this.basce.faxCh = res.data.templateData.faxCh;
        this.basce.faxEn = res.data.templateData.faxEn;

        this.Conductor = res.data.templateData.Conductor;
        this.Conductor.type = 1;
        this.Contactperson = res.data.templateData.Contactperson;
        this.Contactperson.type = 1;
        this.conductors = res.data.templateData.conductors;
        this.conductors.type = 1;
        this.organizations = res.data.templateData.organizations;
        this.organizations.type = 1;
        this.Organizainfor = res.data.templateData.Organizainfor;
        this.Organizainfor.type = 1;
        this.Lengthstay = res.data.templateData.Lengthstay;
        this.Lengthstay.type = 1;
        this.numberrooms = res.data.templateData.numberrooms;
        this.numberrooms.type = 1;
        this.Transportation = res.data.templateData.Transportation;
        this.Transportation.type = 1;
        this.activities = res.data.templateData.activities;
        this.activities.type = 1;
        this.documents = res.data.templateData.documents;
        this.documents.type = 1;
        this.Scores = res.data.templateData.Scores;
        this.Scores.type = 1;
      });
    },
    submits(states) {
      //获取联系人信息 Contact person
      this.Contactperson = this.$refs.Contactperson.contact;
      //获取指挥或艺术总监
      this.Conductor = this.$refs.Conductor.conductor;
      //获取我们的指挥在世界合唱比赛中还担任以下合唱团的指挥
      this.conductors = this.$refs.conductors.part4;
      //获取我们是下列组织的成员
      this.organizations = this.$refs.organizations.part5;
      //获取>组织信息
      this.Organizainfor = this.$refs.Organizainfor.part6;
      //获取停留时间
      this.Lengthstay = this.$refs.Lengthstay.part7;
      //获取选择住宿类型
      this.numberrooms = this.$refs.numberrooms.part8;
      //获取到达时乘坐的交通工具
      this.Transportation = this.$refs.Transportation.part9;
      //获取所要参加的活动总览
      this.activities = this.$refs.activities.part10;
      //获取同时提交下列文件
      this.documents = this.$refs.documents.part11;
      //获取同时提交歌谱
      this.Scores = this.$refs.Scores.part12;

      let data = {
        fileUrl: this.fileUrl,
        state: states,
        applyId: localStorage.getItem("id"),
        baseInfoDto: {
          teamChorusCh: this.basce.teamChorusCh,
          teamChorusEn: this.basce.teamChorusEn,
          teamPhoneCh: this.basce.teamPhoneCh,
          teamPhoneEn: this.basce.teamPhoneEn,
          teamEmailCh: this.basce.teamEmailCh,
          teamEmailEn: this.basce.teamEmailEn,
          teamNumCh: this.basce.teamNumCh,
          teamNumEn: this.basce.teamNumEn,
          teamRegionNameCh: this.basce.teamRegionNameCh,
          teamRegionNameEn: this.basce.teamRegionNameEn,
        },
        templateData: {
          countryCh: this.basce.countryCh,
          countryEn: this.basce.countryEn,
          streetCh: this.basce.streetCh,
          streetEn: this.basce.streetEn,
          zipCh: this.basce.zipCh,
          zipEn: this.basce.zipEn,
          faxCh: this.basce.faxCh,
          faxEn: this.basce.faxEn,
          websiteCh: this.basce.websiteCh,
          websiteEn: this.basce.websiteEn,
          yearCh: this.basce.yearCh,
          yearEn: this.basce.yearEn,
          Contactperson: {
            sexCh: this.Contactperson.sexCh,
            sexEn: this.Contactperson.sexEn,
            contactnameCh: this.Contactperson.contactnameCh,
            contactnameEn: this.Contactperson.contactnameEn,
            streetCh: this.Contactperson.streetCh,
            streetEn: this.Contactperson.streetEn,
            cityCh: this.Contactperson.cityCh,
            cityEn: this.Contactperson.cityEn,
            zipCh: this.Contactperson.zipCh,
            zipEn: this.Contactperson.zipEn,
            phoneCh: this.Contactperson.phoneCh,
            phoneEn: this.Contactperson.phoneEn,
            faxCh: this.Contactperson.faxCh,
            faxEn: this.Contactperson.faxEn,
            emailCh: this.Contactperson.emailCh,
            emailEn: this.Contactperson.emailEn,
          },
          Conductor: {
            sexCh: this.Conductor.sexCh,
            sexEn: this.Conductor.sexEn,
            contactnameCh: this.Conductor.contactnameCh,
            contactnameEn: this.Conductor.contactnameEn,
            streetCh: this.Conductor.streetCh,
            streetEn: this.Conductor.streetEn,
            cityCh: this.Conductor.cityCh,
            cityEn: this.Conductor.cityEn,
            zipCh: this.Conductor.zipCh,
            zipEn: this.Conductor.zipEn,
            phoneCh: this.Conductor.phoneCh,
            phoneEn: this.Conductor.phoneEn,
            faxCh: this.Conductor.faxCh,
            faxEn: this.Conductor.faxEn,
            emailCh: this.Conductor.emailCh,
            emailEn: this.Conductor.emailEn,
          },
          conductors: {
            teamChorusCh: this.conductors.teamChorusCh,
            teamChorusEn: this.conductors.teamChorusEn,
            addresCh: this.conductors.addresCh,
            addresEn: this.conductors.addresEn,
            dateCh: this.conductors.dateCh,
            dateEn: this.conductors.dateEn,
            nameEn: this.conductors.nameEn,
            nameCh: this.conductors.nameCh,
            contentCh: this.conductors.contentCh,
            contentEn: this.conductors.contentEn,
          },
          organizations: {
            membersCh: this.organizations.membersCh,
            membersEn: this.organizations.membersEn,
            telCh: this.organizations.telCh,
            telEn: this.organizations.telEn,
            codeCh: this.organizations.codeCh,
            codeEn: this.organizations.codeEn,
            otherCh: this.organizations.otherCh,
            otherEn: this.organizations.otherEn,
          },
          Organizainfor: {
            teamChorusCh: this.Organizainfor.teamChorusCh,
            teamChorusEn: this.Organizainfor.teamChorusEn,
            countCh: this.Organizainfor.countCh,
            countEn: this.Organizainfor.countEn,
            scountCh: this.Organizainfor.scountCh,
            scountEn: this.Organizainfor.scountEn,
            allcountCh: this.Organizainfor.allcountCh,
            allcountEn: this.Organizainfor.allcountEn,
            carcountCh: this.Organizainfor.carcountCh,
            carcountEn: this.Organizainfor.carcountEn,
          },
          Lengthstay: {
            arrivalCh: this.Lengthstay.arrivalCh,
            arrivalEn: this.Lengthstay.arrivalEn,
            departureCh: this.Lengthstay.departureCh,
            departureEn: this.Lengthstay.departureEn,
            nightsCh: this.Lengthstay.nightsCh,
            nightsEn: this.Lengthstay.nightsEn,
          },
          numberrooms: {
            Economy: this.numberrooms.Economy,
            personrooms: this.numberrooms.personrooms,
            personrooms2: this.numberrooms.personrooms2,
            Standard1: this.numberrooms.Standard1,
            Standard12: this.numberrooms.Standard12,
            Standard11: this.numberrooms.Standard11,
            Standard2: this.numberrooms.Standard2,
            Standard22: this.numberrooms.Standard22,
            Standard21: this.numberrooms.Standard21,
            FirstClass: this.numberrooms.FirstClass,
            FirstClass2: this.numberrooms.FirstClass2,
            FirstClass1: this.numberrooms.FirstClass1,
            EconomyEn: this.numberrooms.EconomyEn,
            personroomsEn: this.numberrooms.personroomsEn,
            personrooms2En: this.numberrooms.personrooms2En,
            Standard1En: this.numberrooms.Standard1En,
            Standard12En: this.numberrooms.Standard12En,
            Standard11En: this.numberrooms.Standard11En,
            Standard2En: this.numberrooms.Standard2En,
            Standard22En: this.numberrooms.Standard22En,
            Standard21En: this.numberrooms.Standard21En,
            FirstClassEn: this.numberrooms.FirstClassEn,
            FirstClass2En: this.numberrooms.FirstClass2En,
            FirstClass1En: this.numberrooms.FirstClass1En,
          },
          Transportation: {
            myselfcar: this.Transportation.myselfcar,
            airplan: this.Transportation.airplan,
            traincar: this.Transportation.traincar,
            othercar: this.Transportation.othercar,
            airaddress: this.Transportation.airaddress,
            aircompany: this.Transportation.aircompany,
            aircode: this.Transportation.aircode,
            airradio: this.Transportation.airradio,
            trainaddress: this.Transportation.trainaddress,
            trainradio: this.Transportation.trainradio,
            otheraddress: this.Transportation.otheraddress,
            otherradio: this.Transportation.otherradio,
            fillformaddres: this.Transportation.fillformaddres,
            fillformdate: this.Transportation.fillformdate,
            contanctsautograph: this.Transportation.contanctsautograph,
            conductorautograph: this.Transportation.conductorautograph,
            myselfcarEn: this.Transportation.myselfcarEn,
            airplanEn: this.Transportation.airplanEn,
            traincarEn: this.Transportation.traincarEn,
            othercarEn: this.Transportation.othercarEn,
            airaddressEn: this.Transportation.airaddressEn,
            aircompanyEn: this.Transportation.aircompanyEn,
            aircodeEn: this.Transportation.aircodeEn,
            airradioEn: this.Transportation.airradioEn,
            trainaddressEn: this.Transportation.trainaddressEn,
            trainradioEn: this.Transportation.trainradioEn,
            otheraddressEn: this.Transportation.otheraddressEn,
            otherradioEn: this.Transportation.otherradioEn,
            fillformaddresEn: this.Transportation.fillformaddresEn,
            fillformdateEn: this.Transportation.fillformdateEn,
            contanctsautographEn: this.Transportation.contanctsautographEn,
            conductorautographEn: this.Transportation.conductorautographEn,
          },
          activities: {
            teamChorusCh: this.activities.teamChorusCh,
            teamChorusEn: this.activities.teamChorusEn,
            championships: this.activities.championships,
            championshipsEn: this.activities.championshipsEn,
            tournament: this.activities.tournament,
            tournamentEn: this.activities.tournamentEn,
            Performance: this.activities.Performance,
            PerformanceEn: this.activities.PerformanceEn,
            guidance: this.activities.guidance,
            guidanceEn: this.activities.guidanceEn,
            Closceremony: this.activities.Closceremony,
            ClosceremonyEn: this.activities.ClosceremonyEn,
            friendly: this.activities.friendly,
            friendlyEn: this.activities.friendlyEn,
            onlyfriendly: this.activities.onlyfriendly,
            onlyfriendlyEn: this.activities.onlyfriendlyEn,
          },
          documents: {
            recording: this.documents.recording,
            recordingEn: this.documents.recordingEn,
            biography: this.documents.biography,
            biographyEn: this.documents.biographyEn,
            photo: this.documents.photo,
            photoEn: this.documents.photoEn,
          },
          Scores: {
            Musicscore7: this.Scores.Musicscore7,
            MusicscoreEn7: this.Scores.MusicscoreEn7,
            Musicscore5: this.Scores.Musicscore5,
            MusicscoreEn5: this.Scores.MusicscoreEn5,
            Musicscore3: this.Scores.Musicscore3,
            MusicscoreEn3: this.Scores.MusicscoreEn3,
            Musicscore1: this.Scores.Musicscore1,
            MusicscoreEn1: this.Scores.MusicscoreEn1,
            Card: this.Scores.Card,
            CardEn: this.Scores.CardEn,
            cardholder: this.Scores.cardholder,
            cardholderEn: this.Scores.cardholderEn,
            Cardnumber: this.Scores.Cardnumber,
            CardnumberEn: this.Scores.CardnumberEn,
            validity: this.Scores.validity,
            validityEn: this.Scores.validityEn,
            VerificationCode: this.Scores.VerificationCode,
            VerificationCodeEn: this.Scores.VerificationCodeEn,
            autograph: this.Scores.autograph,
            autographEn: this.Scores.autographEn,
            Country: this.Scores.Country,
            CountryEn: this.Scores.CountryEn,
            Date: this.Scores.Date,
            DateEn: this.Scores.DateEn,
            contactperson: this.Scores.contactperson,
            contactpersonEn: this.Scores.contactpersonEn,
            conductor: this.Scores.conductor,
            conductorEn: this.Scores.conductorEn,
          },
        },
      };
      applyupdate(data).then((res) => {
        if (res.code == 200) {
          if (data.state == 0) {
            this.dialogVisible2 = true;
            const TIME_COUNT = 3;
            let timer = setInterval(() => {
              if (this.timee > 0) {
                this.timee--;
              } else {
                this.dialogVisible2 = false;
                clearInterval(timer);
                timer = null;
              }
            }, 1000);
          } else {
            this.$message.success(res.msg);
            this.dialogTableVisible = false;
          }
        } else {
          this.$message.info(res.msg);
        }
      });
    },

    //模板2下载模板附件
    uploa() {
      let data = {
        type: 2,
      };
      template_file(data).then((res) => {
        window.location.href = res.data;
      });
    },
  },
};
</script>

<style scoped="" lang="scss">
.home {
  background: white;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 0px 6px 0px rgba(43, 43, 43, 0.05);
  border-radius: 6px;
  height: 100%;
  display: flex;
  flex-direction: column;

  .el-dialog__wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    /deep/ .el-dialog {
      width: 560px;
      height: 330px;
      border-radius: 12px;
      margin: 0 !important;
      .el-dialog__header {
        background: #24558b;
        border-top-right-radius: 12px;
        border-top-left-radius: 12px;

        .el-dialog__title {
          color: white;
        }

        .el-dialog__headerbtn {
          i {
            color: white;
          }
        }
      }

      .el-dialog__body {
        p {
          font-size: 18px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #fc524c;
          line-height: 52px;
          text-align: center;
        }

        span {
          display: inline-block;
          width: 100%;
          font-size: 24px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #24558b;
          line-height: 48px;
          text-align: center;
          margin-top: 54px;
        }

        .btnboxs {
          display: flex;
          justify-content: space-evenly;
          width: 59%;
          margin: auto;
          margin-top: 50px;

          button {
            width: 100px;
            height: 42px;
            background: #24558b;
            border-radius: 8px;
            color: #ffffff;
            margin: 0;
            padding: 0;
            border: 1px solid transparent; //自定义边框
            outline: none; //消除默认点击蓝色边框效果
            cursor: pointer;
          }

          .info {
            background: #ffffff;
            border: 1px solid #a6aab8;
            color: #838a9d;
          }
        }

        .btnbox {
          display: flex;
          justify-content: space-evenly;
          width: 59%;
          margin: auto;
          margin-top: 20px;

          button {
            width: 100px;
            height: 42px;
            background: #24558b;
            border-radius: 8px;
            color: #ffffff;
            margin: 0;
            padding: 0;
            border: 1px solid transparent; //自定义边框
            outline: none; //消除默认点击蓝色边框效果
            cursor: pointer;
          }

          .info {
            background: #ffffff;
            border: 1px solid #a6aab8;
            color: #838a9d;
          }
        }
      }
    }
  }

  .box {
    margin: auto;
    height: 100%;
    width: 100%;
    overflow-y: scroll;
    margin-bottom: 42px;

    .el-dialog__wrapper {
      display: flex;
      align-items: center;
      justify-content: center;
      /deep/ .el-dialog {
        width: 560px;
        height: 330px;
        border-radius: 12px;
        margin: 0 !important;
        .el-dialog__header {
          background: #24558b;
          border-top-right-radius: 12px;
          border-top-left-radius: 12px;

          .el-dialog__title {
            color: white;
          }

          .el-dialog__headerbtn {
            i {
              color: white;
            }
          }
        }

        .el-dialog__body {
          p {
            font-size: 18px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #fc524c;
            line-height: 118px;
            text-align: center;
          }

          span {
            display: inline-block;
            width: 100%;
            font-size: 24px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #24558b;
            line-height: 48px;
            text-align: center;
            margin-top: 54px;
          }

          .btnbox {
            display: flex;
            justify-content: space-evenly;
            width: 59%;
            margin: auto;
            margin-top: 20px;

            button {
              width: 100px;
              height: 42px;
              background: #24558b;
              border-radius: 8px;
              color: #ffffff;
              margin: 0;
              padding: 0;
              border: 1px solid transparent; //自定义边框
              outline: none; //消除默认点击蓝色边框效果
              cursor: pointer;
            }

            .info {
              background: #ffffff;
              border: 1px solid #a6aab8;
              color: #838a9d;
            }
          }
        }
      }
    }

    .header {
      display: flex;
      justify-content: space-between;
      width: 90%;
      margin: 48px 48px;

      .title {
        font-size: 24px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #3c4353;
      }
    }

    .cont {
      .bottoms {
        width: 100%;
        height: 132px;
        margin-top: 96px;
        box-shadow: 0px 0px 10px 0px rgba(8, 27, 42, 0.1);
        display: flex;
        justify-content: center;

        .el-button {
          height: 42px;
          margin-left: 50px;
          margin-top: 57px;
        }
      }
      .uploadform {
        display: flex;
        height: 60px;
        justify-content: space-between;
        padding-left: 100px;
        padding-right: 100px;
        margin-top: 20px;

        div {
          height: 60px;
          font-size: 24px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          color: #167afc;
          line-height: 60px;
          cursor: pointer;
          /deep/ .el-upload-list {
            display: none;
          }
        }
      }
      .part1 {
        .texterar {
          div {
            width: 100%;

            label {
              font-size: 20px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #3c4353;
              line-height: 34px;
            }

            .el-textarea {
              min-height: 200px;

              /deep/.el-textarea__inner {
                min-height: 200px !important;
              }
            }
          }
        }

        .listdiv {
          display: flex;
          justify-content: space-between;

          div {
            width: 30%;

            label {
              font-size: 20px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #3c4353;
              line-height: 34px;
            }

            .el-input {
              width: 100%;
            }

            .el-select {
              width: 100%;
            }
          }
        }

        li {
          display: flex;
          padding-left: 100px;
          padding-right: 100px;
          margin-top: 20px;

          /deep/ .el-input-group__prepend {
            border-right: 0;
            color: rgba(36, 85, 139, 1);
            background: white;
          }
        }

        li:nth-child(3) {
          margin-top: 30px;
        }

        li:nth-child(5) {
          margin-top: 30px;
        }

        li:nth-child(7) {
          margin-top: 30px;
        }

        li:nth-child(9) {
          margin-top: 30px;
        }

        li:nth-child(11) {
          margin-top: 30px;
        }
      }

      .part2 {
        .title {
          font-size: 24px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          color: #3c4353;
          margin: 48px 48px;
        }

        li {
          display: flex;
          padding-left: 100px;
          padding-right: 100px;
          margin-top: 20px;

          /deep/ .el-input-group__prepend {
            border-right: 0;
            color: rgba(36, 85, 139, 1);
            background: white;
          }

          .radiobox {
            width: 30%;
            border: 1px solid gainsboro;

            .el-radio {
              margin-left: 30px;
              margin-top: 14px;
            }
          }
        }

        li:nth-of-type(3) {
          margin-top: 30px;
        }

        li:nth-of-type(5) {
          margin-top: 30px;
        }
      }
    }
  }
}
</style>
